(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-its-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  var LEVELS = { 'none': 0, 'metadata': 1, 'auto': 2 };

  function isVisible(el) {
    return el.offsetParent !== null;
  }

  // Hebt preload schrittweise: none -> metadata -> auto.
  // load() wird nur EINMAL gerufen (beim ersten Upgrade), sonst bricht
  // der laufende Range-Request ab. Spätere Upgrades setzen nur das
  // Attribut – der Browser puffert dann von selbst weiter.
  function setPreload(video, level) {
    if (!video) return;
    var current = video.getAttribute('preload') || 'none';
    if ((LEVELS[level] || 0) <= (LEVELS[current] || 0)) return;
    video.setAttribute('preload', level);
    if (!video.__kbLoaded) {
      video.__kbLoaded = true;
      try { video.load(); } catch (e) {}
    }
  }

  function activate(box) {
    var video = box.querySelector('.video-box__player');
    if (!video) return;
    setPreload(video, 'auto');
    video.controls = true;
    video.removeAttribute('aria-hidden');
    var btn = box.querySelector('.video-box__play');
    if (btn) btn.remove();
    var poster = box.querySelector('.video-box__poster');
    if (poster) {
      poster.style.transition = 'opacity .2s ease';
      poster.style.opacity = '0';
      setTimeout(function () { if (poster && poster.parentNode) poster.remove(); }, 220);
    }
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  var boxes = document.querySelectorAll('.how-its-works-wrapper .video-box--lazy');
  if (!boxes.length) return;

  // Sanfte Strategie: nur Metadata (~50-100KB für moov-Atom + erste Bytes)
  // sobald die Box nahe am Viewport ist. Reicht für Codec/Dauer/Header,
  // ohne nennenswerten Daten-Verbrauch. Hidden Boxen feuern nicht.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        if (!isVisible(entry.target)) { io.unobserve(entry.target); return; }
        var v = entry.target.querySelector('.video-box__player');
        setPreload(v, 'metadata');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px' });
    boxes.forEach(function (box) { io.observe(box); });
  }

  // Bei klarer Intent (hover/touchstart) auf volle Vorpufferung hochstufen.
  // touchstart feuert ~100-200ms vor click und gibt Mobile genug Vorsprung.
  boxes.forEach(function (box) {
    var btn = box.querySelector('.video-box__play');
    if (!btn) return;
    var intent = function () {
      if (!isVisible(box)) return;
      var v = box.querySelector('.video-box__player');
      setPreload(v, 'auto');
    };
    btn.addEventListener('pointerenter', intent, { once: true, passive: true });
    btn.addEventListener('touchstart', intent, { once: true, passive: true });
    btn.addEventListener('click', function () { activate(box); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
